import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'app-how-to',
  templateUrl: './how-to.component.html',
  styleUrls: ['./how-to.component.css']
})
export class HowToVerifyIndentityComponent implements OnInit {

  constructor(private router: Router) { }

  dateNow: string;

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.dateNow = moment().format('dddd, MMMM Do YYYY');
  }

}
